import React from 'react';

const CONSENT_KEY = 'letterweave_cookie_consent';

interface CookieConsentProps {
  onOpenPrivacy: () => void;
}

const CookieConsent: React.FC<CookieConsentProps> = ({ onOpenPrivacy }) => {
  const [visible, setVisible] = React.useState(false);

  React.useEffect(() => {
    if (typeof window === 'undefined') return;
    try {
      const v = window.localStorage.getItem(CONSENT_KEY);
      if (v !== 'accepted') setVisible(true);
    } catch {}
  }, []);

  const accept = () => {
    try { window.localStorage.setItem(CONSENT_KEY, 'accepted'); } catch {}
    setVisible(false);
  };

  if (!visible) return null;
  return (
    <div className="cookie-banner" role="region" aria-label="Cookie consent">
      <div className="cookie-text">
        We use cookies for gameplay saves and to show ads. 
        <button className="cookie-link" onClick={onOpenPrivacy}>Learn more</button>
      </div>
      <button className="cookie-accept" onClick={accept}>Accept</button>
    </div>
  );
};

export default CookieConsent;


